import React from 'react';
import './App.css';
import NavBar from './NavBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import PortfolioSection from './PortfolioSection';
import AboutSection from './AboutSection';
import ContactSection from './ContactSection';
import FooterSection from './FooterSection';
import WhatsAppIcon from './WhatsAppIcon';
import SocialIcons from './SocialIcons';

function App() {
  return (
    <div className="App">
      <NavBar />
      <HeroSection />

      <header className="App-header">
              <ServicesSection />
              {/* ... el resto dek contenido ... */}
      </header>
      <PortfolioSection />
      <AboutSection />
      <ContactSection />
      <SocialIcons />
      <FooterSection />
      <WhatsAppIcon />
    </div>
  );
}

export default App;
